import { useQuery } from 'react-query';
import request from '../../../../../helpers/request';
import { queryKeysShutdowns } from '../../constants/queryKeys';

const getSavedFilters = async () => {
  return await request.get(
    `/Filter/default`,
    { type: 'ALERT' },
    'Произошла ошибка при загрузке фильтра по умолчанию'
  );
};

const useDefaultFilterQuery = (options) =>
  useQuery(queryKeysShutdowns.defaultFilter(), getSavedFilters, options);

export default useDefaultFilterQuery;
